<template>
  <div>
    <el-form-item label="课文">
      <KewenSelect v-model="form.entity_id"></KewenSelect>
    </el-form-item>
  </div>
</template>

<script>
import KewenSelect from "@/components/kewen/KewenSelect.vue";

export default {
  name: "ai_kewen_form",
  components: {KewenSelect},
  props: {
    form: Object
  }
}
</script>